import * as React from 'react';

export type Props = {
  description: React.ReactNode;
  isCollapsed: boolean;
  collapseAll: () => void;
  expandAll: () => void;
};

export const OnboardingAccordionHeader = (props: Props) => {
  const { description, isCollapsed, collapseAll, expandAll } = props;

  return (
    <div className="d-flex ml-1 mb-3">
      <p className="flex-grow-1">{description}</p>
      {isCollapsed && (
        <span
          className="ob-expand-collapse-accordion ob-button"
          onClick={expandAll}
          data-cy="expand-all"
        >
          &#x02795;
        </span>
      )}
      {!isCollapsed && (
        <span
          className="ob-expand-collapse-accordion ob-button"
          onClick={collapseAll}
          data-cy="collapse-all"
        >
          &#x2796;
        </span>
      )}
    </div>
  );
};
